import script from "./TagsListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagsListView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fadbc97"]])

export default __exports__